<template>
  <el-col class="mt-21" :lg="8" :md="8" :sm="24" :xs="24">
    <div class="fill fill-grey fill-sm skeleton">
      <br/><br/><br/><br/><br/><br/><br/>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "ProfileCertSkeleton"
}
</script>

<style scoped>

</style>